﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'add-to-basket-btn',
    props: ['exitpageurl'],
    computed:
    Object.assign(
        mapState({
            maxNumberOfVas: state => state.offeringpage.vas.maxNumberOfVas,
            selectedVas: state => state.offeringpage.vas.selectedVas
        })
    ),
    methods: {
        addToBasket() {
            this.$store.dispatch('addToBasket',this.exitpageurl);
            // redirect the browser after adding to the basket
            //if (this.selectedVas && this.selectedVas.length > 0 && this.exitpageurl) {
            //    window.location.replace(this.exitpageurl);
            //}
        }
    }
}
